import { useMemo } from "react"

import { useTheme } from "@emotion/react"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { ColoredBadge } from "@l2r-front/l2r-ui"

import { getDisplayedFigures } from "../../utils/getDisplayedFigures"
import { getLegendItemForGrade } from "../../utils/getLegendItemForGrade"

export function GradeBadge(props) {

    const {
        className,
        id,
        figuresCount,
        grade,
        legend,
    } = props

    const theme = useTheme()

    const legendItemForGrade = useMemo(() => {
        if (legend && typeof grade === "number" && theme) {
            return getLegendItemForGrade(legend, grade, theme)
        }
    }, [grade, legend, theme])

    if (!grade && grade !== 0) {
        return <ColoredBadge
            className={className}
            id={id}
            backgroundColor="objects/object-grey"
            text="-"
            textColor={theme.palette["objects/object-black"].main}
        />
    }

    const displayedGrade = getDisplayedFigures(grade, figuresCount)

    if (!legendItemForGrade) {
        return null
    }

    return <ColoredBadge
        id={id}
        backgroundColor={theme.palette[legendItemForGrade.color].main}
        className={className}
        text={displayedGrade}
        textColor={legendItemForGrade.textColor}
    />
}

GradeBadge.defaultProps = {
    figuresCount: 2,
}

GradeBadge.propTypes = {
    className: PropTypes.string,
    grade: PropTypes.number,
    figuresCount: PropTypes.number,
    legend: PropTypes.arrayOf(PropTypes.shape({
        color: PropTypes.string,
        label: PropTypes.string,
        maxValue: PropTypes.number,
        minValue: PropTypes.number,
    })),
}